import { FC, useContext, useEffect, useRef, useState } from "react"
import { Link, useLocation } from "react-router-dom";
import Select, { GroupBase, OptionsOrGroups, PropsValue, SingleValue } from 'react-select';

import ContactAndSafetyInfo from "../contactAndSafetyInfo";

import { AuthContext } from "src/context/authContext";
import useFetch from "src/hooks/useFetch";
import { secondFormatPhoneNumber } from "src/helpers";

import { TextAlignProps } from "../contactAndSafetyInfo/types";
import { APIEndpoints } from "src/types/apiTypes";
import { UserListApiResponse, UserObjectType, authstatprops } from "./types";
import { HCPUserSubHeaderProps } from "src/types/users";



const AuthSubHeader: FC<authstatprops> = ({ defaultUser, reTriggerPatientStats }): JSX.Element => {
  const [userChange, setuserChange] = useState<PropsValue<number>>();

  const { isManufacturer, sub_header, userData } = useContext(AuthContext);
  // const { hideLoader } = useContext(LoaderContext);
  const firstUpdate = useRef(true);
  const location = useLocation()


  const allowedRoles = ["Manufacturer", "regional_manager", "area_manager","district_manager","fad"];
  const isAllowedUser = userData?.ref_type && allowedRoles.includes(userData.ref_type);
  const isRep = userData?.ref_type === "rep";

  const isAllowedPage =
    !location.pathname.includes("createuser") &&
    !location.pathname.includes("updateuser") &&
    !location.pathname.includes("eobs") &&
    !location.pathname.includes("user")


  const handleUserChange = (value: SingleValue<number>) => {
    setuserChange(value);
    const { label, value: selectedId, role } = value as unknown as { label: string; value: number, role: string };
    const UserObject: UserObjectType = {
      id: selectedId,
      role: role,
      fullname: label
    }
    reTriggerPatientStats && reTriggerPatientStats(UserObject);
  }

  const { data: UserListStatisticsData, mutate: userListMutate } =
    useFetch<UserListApiResponse>(APIEndpoints.USER_LIST_STATISTICS, {}, {}, false);

  useEffect(() => {
    if (isManufacturer) {
      const selectedValue = {
        label: userData ? userData.name : "",
        value: userData ? userData.id : 0
      }
      setuserChange(selectedValue as unknown as PropsValue<number>);

      if (firstUpdate.current) {
        if (userData && userData.ref_type !== "rep" &&
          (!(location.pathname.includes("createuser") || location.pathname.includes("updateuser")))
        ) {
          firstUpdate.current = false;
           userListMutate()
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (UserListStatisticsData && UserListStatisticsData.data && UserListStatisticsData.data.length > 0) {
      if (defaultUser && (userChange as unknown as { id: string }).id !== defaultUser?.id) {
        const findUser = defaultUser?.id ? UserListStatisticsData.data.find((user) => user.id === Number(defaultUser.id)) : null;
        if (findUser) {
          setuserChange({ value: findUser.id, role: findUser.role, label: findUser.fullname } as unknown as PropsValue<number>)
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [UserListStatisticsData, defaultUser])

  // useEffect(() => {
  //   if (UserListStatisticsData?.code || UserListStatisticsError) {
  //     console.log({UserListStatisticsError});
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [UserListStatisticsData, UserListStatisticsError]);

  // return (
  //   <div className="row align-items-start mt-3 mb-3">
  //     <div className="col-12 col-md-6">
  //       { 
  //         (userData && 
  //         userData.ref_type && 
  //         (userData.ref_type !== "rep") && 
  //         ( userData.ref_type === "Manufacturer" || userData.ref_type === "regional_manager" || userData.ref_type === "district_manager" || userData.ref_type === "area_manager")) 
  //       ? (
  //         !(location.pathname.includes("createuser") || location.pathname.includes("updateuser") || location.pathname.includes('eobs')) && (
  //           <Select
  //             value={userChange}
  //             options={(UserListStatisticsData && UserListStatisticsData.data && UserListStatisticsData.data.length > 0 ?
  //               UserListStatisticsData.data.map((item) => ({
  //                 value: item.id,
  //                 label: item.fullname,
  //                 role: item.role
  //               }))
  //               : []
  //             ) as unknown as OptionsOrGroups<number, GroupBase<number>>}
  //             isSearchable={false}
  //             noOptionsMessage={() => "Select Option..."}
  //             onChange={handleUserChange}
  //           />
  //         )
  //       ) : (
  //         userData && userData.ref_type  && (userData.ref_type !== "rep") &&
  //         <>
  //           <p className="mb-1">
  //             <span className="fw-bold">Your Field Access Manager is:</span>{' '}
  //             {sub_header ? (sub_header as HCPUserSubHeaderProps)["Your Field Access Manager is:"] : ""}
  //           </p>
  //           <p className="mb-1">
  //             <span className="fw-bold">Email:</span>{' '}
  //             {sub_header ? (
  //               <a
  //                 href={`mailto:${(sub_header as HCPUserSubHeaderProps)["Email:"]}`}
  //                 className="btn btn-link link-offset-0 link-offset-0-hover link-underline link-underline-opacity-0 link-underline-opacity-100-hover p-0 align-baseline"
  //               >
  //                 {(sub_header as HCPUserSubHeaderProps)["Email:"]}
  //               </a>)
  //               : ""
  //             }
  //           </p>
  //           <p className="mb-1">
  //             <span className="fw-bold">Phone:</span>{' '}
  //             {sub_header && ((sub_header as HCPUserSubHeaderProps)["Phone:"]) ? formatPhoneNumber((sub_header as HCPUserSubHeaderProps)["Phone:"]) : ""}
  //           </p>
  //           <p className="fw-bold mb-2">
  //             To schedule a visit with Demo FAM,{' '}
  //             <Link to="/rep_visits/new" className="link-offset-0 link-offset-0-hover link-underline-primary link-underline-opacity-0 link-underline-opacity-75-hover">
  //               Click here
  //             </Link>
  //           </p>
  //         </>
  //       )
  //       }
  //     </div>
  //     <div className="col-12 col-md-6">
  //       <ContactAndSafetyInfo textColor="black" alignText={TextAlignProps.TEXT_END} />
  //     </div>
  //   </div>
  // );
  return (
    <div className="row align-items-start mt-3 mb-3">
      <div className="col-12 col-md-6">
        {isAllowedUser && !isRep ? (
          isAllowedPage && !window.location.pathname.includes("global_patients") ? (
            // <Select
            //   value={userChange}
            //  options={(UserListStatisticsData && UserListStatisticsData.data && UserListStatisticsData.data.length > 0 ?
            //        UserListStatisticsData.data.map((item) => ({
            //          value: item.id,
            //          label: item.fullname,
            //          role: item.role
            //        }))
            //        : []
            //      ) as unknown as OptionsOrGroups<number, GroupBase<number>>}
            //   isSearchable={true}
            //   noOptionsMessage={() => "Select Option..."}
            //   onChange={handleUserChange}
            // />
            <Select
              value={userChange}
              options={
                (UserListStatisticsData?.data?.length
                  ? UserListStatisticsData.data.map((item) => ({
                    value: item.id,
                    label: item.fullname,
                    role: item.role,
                  }))
                  : []) as unknown as OptionsOrGroups<number, GroupBase<number>>
              }
              isSearchable={true}
              noOptionsMessage={() => "Select Option..."}
              onChange={handleUserChange}
              menuShouldScrollIntoView={false}  // Prevents auto scroll to top
              menuPlacement="auto"
              classNamePrefix="user-select"
              onMenuOpen={() => {
                // Wait for menu render, then scroll selected option into view
                setTimeout(() => {
                  const selectedOption = document.querySelector(
                    ".user-select__option--is-selected"
                  );
                  selectedOption?.scrollIntoView({ block: "nearest" });
                }, 10);
              }}
            />
          ) : null
        ) : !isManufacturer ? (
          <>
            <p className="mb-1">
              <span className="fw-bold">Your Field Access Manager is:</span>{" "}
              {sub_header
                ? (sub_header as HCPUserSubHeaderProps)["Your Field Access Manager is:"]
                : ""}
            </p>
            <p className="mb-1">
              <span className="fw-bold">Email:</span>{" "}
              {sub_header && (
                <a
                  href={`mailto:${(sub_header as HCPUserSubHeaderProps)["Email:"]}`}
                  className="btn btn-link link-offset-0 link-offset-0-hover link-underline link-underline-opacity-0 link-underline-opacity-100-hover p-0 align-baseline"
                >
                  {(sub_header as HCPUserSubHeaderProps)["Email:"]}
                </a>
              )}
            </p>
            {<p className="mb-1">
              <span className="fw-bold">Phone:</span>{' '}
              {sub_header && ((sub_header as HCPUserSubHeaderProps)["Phone:"]) ? secondFormatPhoneNumber((sub_header as HCPUserSubHeaderProps)["Phone:"] || "") : ""}
            </p>}
            <p className="fw-bold mb-2">
              To schedule a visit with Demo FAM,{" "}
              <Link
                to="/rep_visits/new"
                className="link-offset-0 link-offset-0-hover link-underline-primary link-underline-opacity-0 link-underline-opacity-75-hover"
              >
                Click here
              </Link>
            </p>
          </>
        ) : null}
      </div>

      <div className="col-12 col-md-6">
        <ContactAndSafetyInfo
          textColor="black"
          alignText={TextAlignProps.TEXT_END}
        />
      </div>
    </div>
  );
};

export default AuthSubHeader;
